export const informedConfig = {
  errorMessage: {
    required: 'Toto pole je povinné'
  }
} as const;
